<template>
  <v-layout>
    <v-data-table
      @click:row="rowClick"
      item-key="cpfCnpj"
      single-select
      fixed-header
      height="calc(100vh - 216px)"
      :headers="headers"
      :items="clientes"
      class="elevation-1"
      :search="search"
      :items-per-page="50"
      single-expand
      show-expand
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat height="64px">
          <v-toolbar-title>Clientes</v-toolbar-title>
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Localizar"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>

      <template v-slot:item.cpfCnpj="{ item }">
        <v-chip color="secondary lighten-4">{{ item.cpfCnpj }}</v-chip>
      </template>

      <template v-slot:item.data-table-expand="{ item }">
        <v-speed-dial
          v-if="item.cpfCnpj === selected"
          :v-model="fab"
          direction="left"
          transition="slide-x-reverse-transition"
          :style="$vuetify.breakpoint.xsOnly ? 'bottom: 8px' : 'bottom: 0px'"
        >
          <template v-slot:activator>
            <v-btn color="rgba(0, 0, 0, 0.4)" dark small fab>
              <v-icon v-if="fab">mdi-close</v-icon>
              <v-icon v-else>more_vert</v-icon>
            </v-btn>
          </template>
          <v-btn fab dark small color="green" @click="editarCliente">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn fab dark small color="red" @click="deletarCliente">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-speed-dial>
        <div v-else :v-show="$vuetify.breakpoint.mdAndUp" style="width: 40px" />
      </template>
    </v-data-table>
    <cliente
      :open="openDialog"
      :dadosCliente="dadosCliente"
      :onClose="() => (openDialog = false)"
      :onSave="onSave"
    />
    <v-btn
      fab
      dark
      small
      :color="$vuetify.theme.secondary"
      @click="novoCliente"
      absolute
      bottom
      class="mb-11 ml-4"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
import api from "../api/index.js";
import Cliente from "./dialogs/Cliente.vue";

export default {
  components: {
    Cliente
  },
  data() {
    return {
      fab: false,
      openDialog: false,
      loading: true,
      selected: "",
      search: "",
      clienteSelecionado: null,
      dadosCliente: null,
      headers: [
        { text: "CPF / CNPJ", value: "cpfCnpj", width: "150px" },
        { text: "Nome", value: "nomeRazaoSocial" },
        { text: "Cidade", value: "municipio[0].nome" },
        {
          text: "Estado",
          value: "municipio[0].microrregiao.mesorregiao.UF.sigla"
        },
        { text: "", value: "data-table-expand" }
      ],
      clientes: []
    };
  },
  created: function() {
    this.getData();
  },
  methods: {
    editarCliente: function() {
      this.dadosCliente = this.clienteSelecionado;
      this.openDialog = true;
    },
    novoCliente: function() {
      this.dadosCliente = null;
      this.openDialog = true;
    },
    deletarCliente: function() {
      this.$store.commit("showShowMessage", {
        title: "Confirmação",
        message: "Deseja deletar este cliente?",
        subMessage: this.clienteSelecionado.nomeRazaoSocial,
        buttons: {
          ok: {
            label: "Sim",
            visible: true,
            onClick: function() {
              api.deleteCliente(this.clienteSelecionado, data => {
                this.clientes = this.clientes.filter(
                  cliente => cliente._id !== this.clienteSelecionado._id
                );
                this.clienteSelecionado = null;
              });
            }.bind(this)
          },
          cancel: { label: "Não" }
        }
      });
    },
    onSave: function(data, isNew) {
      this.openDialog = false;
      if (isNew) {
        this.clientes.push(data);
        this.search = data.cpfCnpj;
        this.clienteSelecionado = { ...data };
      } else {
        this.clientes = this.clientes.map(cliente =>
          cliente._id === data._id ? data : cliente
        );
        const temp = {
          ...data,
          endereco: { ...data.endereco, cidadeNome: data.municipio[0].nome }
        };
        delete temp.municipio;
        delete temp.empresa;
        this.clienteSelecionado = { ...temp };
        this.selected = data.cpfCnpj;
      }
    },
    rowClick: function(item, row) {
      row.select(true);
      const temp = {
        ...item,
        endereco: { ...item.endereco, cidadeNome: item.municipio[0].nome }
      };
      delete temp.municipio;
      delete temp.empresa;
      this.clienteSelecionado = { ...temp };
      this.selected = item.cpfCnpj;
    },
    getData: function() {
      this.loading = true;
      api.getClientes(
        data => {
          this.clientes = data;
          this.loading = false;
        },
        error => {
          this.loading = false;
        }
      );
    }
  }
};
</script>

<style>
.v-data-table {
  width: 100%;
}
.v-data-footer {
  margin-right: 0px !important;
  height: 64px !important;
}
.v-data-footer__select {
  display: none !important;
}
.v-data-table--fixed-header {
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}
.v-data-table td,
.v-data-table th {
  padding: 4px 16px !important;
}
tr.v-data-table__selected,
tr.v-data-table__mobile-table-row__selected {
  background: rgba(0, 0, 0, 0.1) !important;
}
tr.v-data-table__mobile-table-row {
  display: block !important;
  width: 100%;
  height: 100%;
}
.v-speed-dial {
  position: absolute;
}
.v-btn--floating {
  position: relative;
}
</style>
